import { useEffect, useState } from 'react';
import { auth, db } from '../Firebase/Firebase';
import { doc, getDoc, updateDoc, setDoc } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';

const ProcesarReclamo = () => {
  const [estado, setEstado] = useState('Verificando...');
  const navigate = useNavigate();

  useEffect(() => {
    const user = auth.currentUser;
    if (!user) {
      setEstado('No hay usuario autenticado.');
      return;
    }

    const uid = user.uid;
    const userRef = doc(db, 'usuarios', uid);

    const procesar = async () => {
      const snap = await getDoc(userRef);
      const coinsPorReclamo = 500;

      if (snap.exists()) {
        const data = snap.data();
        if (data?.coinsClaimed) {
          setEstado('Ya reclamaste tus coins 🎉');
        } else {
          await updateDoc(userRef, {
            coins: (data.coins || 0) + coinsPorReclamo,
            coinsClaimed: true,
            coinsComprados: (data.coinsComprados || 0) + coinsPorReclamo

          });
          setEstado(`¡Reclamaste ${coinsPorReclamo} coins! 🎉`);
        }
      } else {
        await setDoc(userRef, {
          coins: coinsPorReclamo,
          coinsClaimed: true
        });
        setEstado(`¡Reclamaste ${coinsPorReclamo} coins! 🎉`);
      }

      // Limpia localStorage
      localStorage.removeItem('isClaiming');

      // Puedes redirigir después de unos segundos si deseas
      setTimeout(() => {
        navigate('/wallet');
      }, 3000);
    };

    procesar();
  }, []);

  return (
    <div style={{ textAlign: 'center', padding: '40px' }}>
      <h2>{estado}</h2>
    </div>
  );
};

export default ProcesarReclamo;
